import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import ReactGA from 'react-ga';

import moment from 'moment';

import LicensePanelGroupComponent from '../../../components/profile/Licenses/LicensePanelGroupComponent';
import ModalComponent from '../../core/ModalComponent/ModalComponent';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';
import TruncateComponent from '../../core/TruncateComponent/TruncateComponent';
import DropDownComponent from '../../core/DropDownComponent/DropDownComponent';
import LicenseOuterFormContainer from '../../../containers/LicenseOuterFormContainer';
import LicensePlatformIconComponent from './LicensePlatformIconComponent';
import { LICENSES_MENU } from '../../core/MenuComponent/MenuConstants';
import { PLATFORM_NAMES } from '../../../constants/common';

import './licenses.scss';

const ACTIONS = {
    move: 'move',
    delete: 'delete',
    add: 'add',
    editDev: 'editDev',
    editProd: 'editProd',
};

const errorMessage = {
    '318': 'This license cannot be deleted because it is in production. Please contact Support.',
    '319': 'This license cannot be deleted because users exist for this license.',
    '317': 'Unknown error. Please try again at a later time.',
}

const LICENSES_ACTION = {
    ...LICENSES_MENU,
};

const initialValues = {};
let isCreateAction = true;

class LicensesComponent extends React.Component {
    constructor(props) {
        super(props);

        this.showModal = this.showModal.bind(this);

        this.state = {
            showModal: false,
            modalTitle: '',
            modalBody: '',
            modalConfirmButtonTitle: 'Yes',
            modalCancelButtonTitle: 'No',
            activeKey: this.props.activePanel,
            modalOnConfirm: () => {},
            error: '',
            modalPage: 1,
            showTooltip: {},
            subEnabledHere: false,
        };

        this.GRID_PROPS = [
            {
                className: 'name',
                getter: (item) => <div>
                    <LicensePlatformIconComponent item={item} handleView={this.handleView} />
                    <div className="placeholder">
                        <TruncateComponent lines={1} className="main" text={item.name} />
                        <TruncateComponent lines={2} className="description" text={item.description} />
                    </div>
                </div>,
            },
            {
                id: 'platform-category',
                title: 'Platform',
                className: 'platform',
                getter: (item) => <div>
                    {item.category}
                    <p>{item.platform}</p>
                </div>,
            },
            {
                className: 'license-date',
                getter: (item) => {
                    const lastUpdated = moment(item.lastUpdated);

                    return <div>
                        <div>{item.license}</div>
                        <span className="license-updated-date">Updated: {lastUpdated.format('MMM DD, YYYY')} at {lastUpdated.format('hh:mm A')}</span>
                    </div>
                },
            },
            {
                title: 'Ellipsis',
                className: 'ellipsis',
                getter: (item) => {
                    let menuItems = [];
                    Object.keys(LICENSES_ACTION).forEach((key) => {
                        if (item.env === 'dev' && LICENSES_ACTION[key].forDev) {
                            if ((key === 'move-production' || key === 'delete-license') && this.props.canEdit && !item.inProd) {
                                menuItems.push({
                                    title: LICENSES_ACTION[key].title,
                                    action: LICENSES_ACTION[key].action,
                                });
                            } else if (key !== 'move-production' && key !== 'delete-license') {
                                if ((key === 'edit-license' && !item.inProd) || (key === 'edit-dev-license' && item.inProd)) {
                                    menuItems.push({
                                        title: LICENSES_ACTION[key].title,
                                        action: LICENSES_ACTION[key].action,
                                    });
                                }
                            }
                        } else if (item.env === 'prod' && !LICENSES_ACTION[key].forDev) {
                            menuItems.push({
                                title: LICENSES_ACTION[key].title,
                                action: LICENSES_ACTION[key].action,
                            });
                        }
                    });

                    return <DropDownComponent
                        eventKey={1}
                        className='license-dropdown'
                        title={<span className="ellipsis-span" />} id='members-menu'>
                        {menuItems.map(({title, action}, index) =>
                            <MenuItem className={action}
                                key={index}
                                eventKey={title}
                                onSelect={() => this.licenseAction(action, item)}
                            >{title}</MenuItem>
                        )}
                    </DropDownComponent>
                },
            },
        ];
    }

    showModal = (action, licenseData) => {
        let state = {};

        ReactGA.event({
            category: 'Licenses Component',
            action: 'Clicked Add Icon',
            label: 'Icon',
        });

        if (action === ACTIONS.move) {
            isCreateAction = false;
            let data = licenseData;
            state = {
                action: ACTIONS.move,
                modalTitle: 'Move License to production',
                modalBody: this.renderForm(data, action, data && data.platform === PLATFORM_NAMES.web ? 2 : 1, true),
                modalConfirmButtonTitle: 'Move',
                modalCancelButtonTitle: 'Cancel',
                modalOnConfirm: this.props.moveLicenseForm,
                pageAmount: data && data.platform === PLATFORM_NAMES.web ? 2 : 1,
            };
        } else if (action === ACTIONS.add) {
            isCreateAction = true;
            state = {
                action: ACTIONS.add,
                modalTitle: 'Add License',
                modalBody: this.renderForm(licenseData, action, licenseData && licenseData.platform === PLATFORM_NAMES.web ? 2 : 1, true),
                modalConfirmButtonTitle: 'Create',
                modalCancelButtonTitle: 'Cancel',
                modalOnConfirm: this.props.submitLicenseForm,
                pageAmount: licenseData && licenseData.platform === PLATFORM_NAMES.web ? 2 : 1,
            };
        } else if (action === ACTIONS.editDev) {
            const { devInProd } = this.props.licenses;

            isCreateAction = false;
            if (licenseData.env === 'prod') {
                for (var license in devInProd) {
                    if (devInProd[license].firebaseId === licenseData.firebaseId) {
                        licenseData = devInProd[license];
                        break;
                    }
                }
            }
            state = {
                action: ACTIONS.editDev,
                modalTitle: 'Edit License [Development]',
                modalBody: this.renderForm(licenseData, action, licenseData && licenseData.platform === PLATFORM_NAMES.web ? 2 : 1, true),
                modalConfirmButtonTitle: 'Update',
                modalCancelButtonTitle: 'Cancel',
                modalOnConfirm: this.props.editDevLicenseForm,
                pageAmount: licenseData && licenseData.platform === PLATFORM_NAMES.web ? 2 : 1,
            };
        } else if (action === ACTIONS.editProd) {
            isCreateAction = false;
            state = {
                action: ACTIONS.editProd,
                modalTitle: 'Edit License [Production]',
                modalBody: this.renderForm(licenseData, action, licenseData && licenseData.platform === PLATFORM_NAMES.web ? 2 : 1, true),
                modalConfirmButtonTitle: 'Update',
                modalCancelButtonTitle: 'Cancel',
                modalOnConfirm: this.props.editProdLicenseForm,
                pageAmount: licenseData && licenseData.platform === PLATFORM_NAMES.web ? 2 : 1,
            };
        } else if (action === ACTIONS.delete) {
            isCreateAction = false;
            state = {
                action: ACTIONS.delete,
                modalTitle: 'Delete License',
                modalBody: this.renderForm(licenseData, action, 1),
                modalConfirmButtonTitle: 'Delete',
                modalCancelButtonTitle: 'Cancel',
                pageAmount: 1,
                modalOnConfirm: () => {
                    let promise;
                    const apigeeAppId = licenseData.apigeeAppId ? licenseData.apigeeAppId : 0;

                    promise = this.props.deleteLicense(this.props.company, licenseData.firebaseId, licenseData.name, this.props.user, apigeeAppId);
                    return promise.then((status) => {
                        if (status === 'OK' || status === '305') {
                            this.closeModal();
                        } else {
                            this.setState({
                                error: errorMessage[status],
                            });
                        }
                    });
                },
            };
        }

        this.setState({
            ...state,
            showModal: true,
            error: '',
            licenseData: licenseData,
            callbacks: null,
            additional: null,
        });
    }

    closeModal = () => {
        ReactGA.event({
            category: 'Licenses Component',
            action: 'Clicked Close Modal Icon',
            label: 'Icon',
        });

        this.setState({
            showModal: false,
            modalPage: 1,
            modalInProgress: false,
            modal2InProgress: false,
            incorrectIds: '',
            callbacks: null,
            additional: null,
        });
    }

    licenseAction = (action, licenseData) => {
        if (action === 'move-license') {
            ReactGA.event({
                category: 'Licenses Component',
                action: 'Clicked Move License to Production',
                label: 'Dropdown',
            });
            this.showModal('move', licenseData);
        } else if (action === 'delete-license') {
            ReactGA.event({
                category: 'Licenses Component',
                action: 'Clicked Delete License',
                label: 'Dropdown',
            });
            this.showModal('delete', licenseData);
        } else if (action === 'edit-prod-license') {
            ReactGA.event({
                category: 'Licenses Component',
                action: 'Clicked Edit Production License',
                label: 'Dropdown',
            });
            this.showModal('editProd', licenseData);
        } else {
            ReactGA.event({
                category: 'Licenses Component',
                action: 'Clicked Edit Dev License',
                label: 'Dropdown',
            });
            this.showModal('editDev', licenseData);
        }
    }

    renderForm = (licenseData, action, pageAmount, isNewModal) => {
        const { platforms } = this.props;
        const toolTipFlag = (action === ACTIONS.move);

        if (action === ACTIONS.add) {
            return <LicenseOuterFormContainer
                initialValues={initialValues}
                isCreateAction={isCreateAction}
                platforms={platforms}
                close={this.closeModal}
                action={action}
                pageAmount={pageAmount}
                page={this.state.modalPage}
                nextPage={this.nextPage}
                prevPage={this.prevPage}
                inProgress={this.state.modalInProgress}
                inProgress2={this.state.modal2InProgress}
                changePlatform={this.changePlatform}
                addIncorrectIds={this.addIncorrectIds}
                incorrectIds={this.state.incorrectIds}
                updateInvalid={this.updateInvalid}
                savedCallbacks={!isNewModal ? this.state.callbacks : null}
                saveCallbacks={this.saveCallbacks}
                savedAdditional={!isNewModal ? this.state.additional : null}
                saveAdditional={this.saveAdditional}
                updateSubEnabled={this.updateSubEnabled}
            />
        } else if (action === ACTIONS.delete) {
            return <div><div>Do you wish to delete the development license for <b>{this.props.company.name}</b>? This cannot be undone.</div><br /></div>
        } else {
            return <LicenseOuterFormContainer
                isCreateAction={isCreateAction}
                initialValues={licenseData}
                close={this.closeModal}
                platforms={platforms}
                action={action}
                toolTipFlag={toolTipFlag}
                pageAmount={pageAmount}
                page={this.state.modalPage}
                nextPage={this.nextPage}
                prevPage={this.prevPage}
                inProgress={this.state.modalInProgress}
                inProgress2={this.state.modal2InProgress}
                addIncorrectIds={this.addIncorrectIds}
                incorrectIds={this.state.incorrectIds}
                updateInvalid={this.updateInvalid}
                savedCallbacks={!isNewModal ? this.state.callbacks : null}
                saveCallbacks={this.saveCallbacks}
                savedAdditional={!isNewModal ? this.state.additional : null}
                saveAdditional={this.saveAdditional}
                updateSubEnabled={this.updateSubEnabled}
            />
        }
    };

    handleView = (action, item) => {
        let temp = this.state.showTooltip;
        temp[item.id] = false;
        this.setState({
            modalPage: 2,
            showTooltip: temp,
        }, () => {
            this.licenseAction(action, item);
        });
    }

    nextPage = () => {
        this.setState({
            modalPage: this.state.modalPage + 1,
            modalInProgress: true,
        }, () => {
            this.setState({
                modalBody: this.renderForm(this.state.licenseData, this.state.action, this.state.pageAmount),
            });
        });
    }

    prevPage = () => {
        this.setState({
            modalPage: this.state.modalPage - 1,
            modal2InProgress: true,
        }, () => {
            this.setState({
                modalBody: this.renderForm(this.state.licenseData, this.state.action, this.state.pageAmount),
            });
        });
    }

    changePlatform = (platformArr) => {
        let platform = '';
        Object.keys(platformArr).forEach(key => {
            if (!isNaN(key)) {
                platform += platformArr[key];
            }
        });
        this.setState({
            pageAmount: platform === PLATFORM_NAMES.web ? 2 : 1,
        }, () => {
            this.setState({
                modalBody: this.renderForm(this.state.licenseData, this.state.action, this.state.pageAmount),
            });
        });
    }

    addIncorrectIds = (ids) => {
        this.setState({
            incorrectIds: ids,
            submitting: false,
        }, () => {
            this.setState({
                modalBody: this.renderForm(this.state.licenseData, this.state.action, this.state.pageAmount),
            });
        });
    }

    updateInvalid = (invalid) => {
        this.setState({
            formInvalid: invalid,
        });
    }

    updateSubEnabled = (subEnabled) => {
        this.setState({
            subEnabledHere: subEnabled,
        });
    }

    saveCallbacks = (callbacks) => {
        this.setState({
            callbacks: callbacks,
        });
    }

    saveAdditional = (additional) => {
        this.setState({
            additional: additional,
        });
    }

    getInvalidCallback = () => {
        const { callbacks, modalPage, subEnabledHere } = this.state;
        let callbackNumber = 0;
        callbacks && Object.keys(callbacks).forEach((callback) => {
            if (callbacks[callback] && callbacks[callback].length > 0) {
                callbackNumber++;
            }
        });
        return subEnabledHere && (callbackNumber <= 0) && (modalPage === 2);
    }

    getInvalidAdditional = () => {
        const { additional, modalPage, subEnabledHere } = this.state;
        let additionalNumber = 0;
        additional && Object.keys(additional).forEach((add) => {
            if (additional[add] && additional[add]) {
                additionalNumber++;
            }
        });
        return subEnabledHere && (additionalNumber <= 0) && (modalPage === 2);
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Licenses Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const {
            licenses: { dev: devLicenses, devInProd: devInProdLicenses, prod: prodLicenses },
            areSelectedItemsEmpty,
            canEdit,
            isLoading,
            isDev,
            backToDevelopment,
        } = this.props;
        const {
            activeKey,
            showModal,
            modalTitle,
            modalConfirmButtonTitle,
            modalCancelButtonTitle,
            modalOnConfirm,
            modalPage,
            pageAmount,
            incorrectIds,
            formInvalid,
            submitting,
        } = this.state;
        let {
            modalBody,
        } = this.state;

        devInProdLicenses.forEach((license) => {
            license.inProd = true;
        });

        let fullDevLicenses = [...devLicenses, ...devInProdLicenses];

        if (this.state.error !== '') {
            modalBody = <div>{modalBody}<div style={{color: 'red'}}>{this.state.error}</div></div>
        } else {
            modalBody = <div>{modalBody}<br /></div>
        }

        return <div>
            {isLoading && <LoadingComponent fullScreen />}
            <div className="licenses-component">
                <h3>Licenses</h3>
                <span className="link">
                    <a onClick={() => this.showModal(ACTIONS.add)}>
                        <span className="add-fonticon" /> Add
                    </a>
                </span>
                {isDev && <span className='prod-key'><span className='prod-icon'>P</span>License added to Production</span>}
                <div>
                    <LicensePanelGroupComponent
                        activeKey={activeKey}
                        canEdit={canEdit}
                        gridProps={this.GRID_PROPS}
                        devLicenses={fullDevLicenses}
                        prodLicenses={prodLicenses}
                        areSelectedItemsEmpty={areSelectedItemsEmpty}
                        isDev={isDev}
                        addLicenseMethod={this.showModal}
                        backToDevelopment={backToDevelopment}
                    />
                </div>
            </div>
            <ModalComponent
                show={showModal}
                handleClose={this.closeModal}
                title={modalTitle}
                body={modalBody}
                cancelButtonTitle={modalCancelButtonTitle}
                confirmButtonTitle={modalConfirmButtonTitle}
                onConfirm={modalOnConfirm}
                pages={pageAmount}
                page={modalPage}
                noCloseButton
                submitting={submitting}
                disableConfirmButton={formInvalid || (this.getInvalidCallback() && this.getInvalidAdditional()) || (!!incorrectIds && incorrectIds.length > 0 && modalPage === 2)}
                setSubmitting={(val) => this.setState({ submitting: val })}
            />
        </div>;
    }
};

LicensesComponent.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    licenses: PropTypes.object.isRequired,
    areSelectedItemsEmpty: PropTypes.bool.isRequired,
    canEdit: PropTypes.bool.isRequired,
    activePanel: PropTypes.string,
    isDev: PropTypes.bool.isRequired,
    platforms: PropTypes.array.isRequired,
    submitLicenseForm: PropTypes.func.isRequired,
    moveLicenseForm: PropTypes.func.isRequired,
    editDevLicenseForm: PropTypes.func.isRequired,
    editProdLicenseForm: PropTypes.func.isRequired,
    deleteLicense: PropTypes.func.isRequired,
    backToDevelopment: PropTypes.func.isRequired,
    company: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

export default LicensesComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Licenses/LicensesComponent.js